import { useEffect } from "react";

/**
 * Tawk.to live chat widget. Loads only when both env vars are set.
 * Set REACT_APP_TAWK_PROPERTY_ID and REACT_APP_TAWK_WIDGET_ID in /app/frontend/.env,
 * then restart the frontend. Sign up free at https://www.tawk.to/ to get IDs.
 */
export default function LiveChat() {
  useEffect(() => {
    const propertyId = process.env.REACT_APP_TAWK_PROPERTY_ID;
    const widgetId = process.env.REACT_APP_TAWK_WIDGET_ID;
    if (!propertyId || !widgetId) return;
    if (document.getElementById("tawk-script")) return;

    window.Tawk_API = window.Tawk_API || {};
    window.Tawk_LoadStart = new Date();
    const s = document.createElement("script");
    s.id = "tawk-script";
    s.async = true;
    s.src = `https://embed.tawk.to/${propertyId}/${widgetId}`;
    s.charset = "UTF-8";
    s.setAttribute("crossorigin", "*");
    document.body.appendChild(s);
  }, []);
  return null;
}
